import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../api';

export default function RuhsatForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const duzenleme = !!id;

  const [form, setForm] = useState({
    sicil_id: '', unvan: '', firma_adi: '', firma_unvani: '', ruhsat_turu_id: '', sicil_tipi_id: '',
    tcno: '', vn: '', vd: '',
    isyeri_adresi: '', is_diskapi: '', is_ickapi: '', is_katno: '',
    is_il: 'ORDU', is_ilce: 'ÜNYE', mahalle: '', sokak: '',
    gis_mahalle_id: '', gis_yol_id: '', gis_kapi_id: '',
    ada: '', pafta: '', parsel: '',
    ana_faaliyet_id: '', kapali_alan: '', acik_alan: '',
    kapasite: '', kapasite_tip: '', oda_sayisi: '', sgk_sayisi: '',
    mulk: '', mulk_sahibi_id: '', yer: '', takip_suresi: '', basvuru_tarihi: new Date().toISOString().split('T')[0],
    yaz_acilis_saati: '', yaz_kapanis_saati: '', kis_acilis_saati: '', kis_kapanis_saati: '',
    depo_adresi: '', depo_diskapi: '', depo_ickapi: '', depo_katno: '', depo_il: '', depo_ilce: '',
    yapi_kayit_belgesi: '', ebelgeno: '', sirket_tipi_id: '', oda_kayit_id: '', nace_kodu_id: '',
  });
  const [taliSecimler, setTaliSecimler] = useState([]); // [{faaliyet_id, faaliyet_adi}]

  const [ruhsatTurleri, setRuhsatTurleri] = useState([]);
  const [sicilTipleri, setSicilTipleri] = useState([]);
  const [sirketTipleri, setSirketTipleri] = useState([]);
  const [faaliyetleri, setFaaliyetleri] = useState([]);
  const [odaKayitlari, setOdaKayitlari] = useState([]);
  const [naceKodlari, setNaceKodlari] = useState([]);
  const [naceArama, setNaceArama] = useState('');
  const [odaModal, setOdaModal] = useState(null); // {oda_adi:'', oda_kodu:''}
  const [naceModal, setNaceModal] = useState(null); // {nace_kodu:'', nace_adi:'', bolum:''}
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');
  const [sicilArama, setSicilArama] = useState('');
  const [sicilSonuclari, setSicilSonuclari] = useState([]);
  const [sonEklenenler, setSonEklenenler] = useState([]);
  // Adres dropdown
  const [mahalleler, setMahalleler] = useState([]);
  const [yollar, setYollar] = useState([]);
  const [kapilar, setKapilar] = useState([]);
  const [seciliMahalleId, setSeciliMahalleId] = useState('');
  const [seciliYolId, setSeciliYolId] = useState('');
  const [yolYukleniyor, setYolYukleniyor] = useState(false);
  const [kapiYukleniyor, setKapiYukleniyor] = useState(false);
  const [adresModalAcik, setAdresModalAcik] = useState(false);
  const [depoAdresModalAcik, setDepoAdresModalAcik] = useState(false);
  const [depoSeciliMahalleId, setDepoSeciliMahalleId] = useState('');
  const [depoSeciliYolId, setDepoSeciliYolId] = useState('');
  const [depoYollar, setDepoYollar] = useState([]);
  const [depoKapilar, setDepoKapilar] = useState([]);
  const [depoYolYukleniyor, setDepoYolYukleniyor] = useState(false);
  const [depoKapiYukleniyor, setDepoKapiYukleniyor] = useState(false);
  const [faaliyetModal, setFaaliyetModal] = useState(null);
  const [yerBolgeSecenekleri, setYerBolgeSecenekleri] = useState(() => {
    try {
      const kayitli = JSON.parse(localStorage.getItem('ruhsat_yer_bolge_secenekleri') || '[]');
      return Array.isArray(kayitli) ? kayitli : [];
    } catch { return []; }
  });

  const yeniYerBolgeEkle = () => {
    const ad = window.prompt('Yeni yer / bölge adını girin:')?.trim();
    if (!ad) return;
    setYerBolgeSecenekleri(prev => {
      const yeni = prev.some(x => x.toLocaleLowerCase('tr') === ad.toLocaleLowerCase('tr')) ? prev : [...prev, ad];
      try { localStorage.setItem('ruhsat_yer_bolge_secenekleri', JSON.stringify(yeni)); } catch {}
      return yeni;
    });
    setForm(prev => ({ ...prev, yer: ad }));
  };

  useEffect(() => {
    Promise.all([
      api.get('/tanimlar/ruhsat-turleri'),
      api.get('/tanimlar/sicil-tipleri'),
      api.get('/tanimlar/faaliyet-turleri'),
      api.get('/gis/mahalleler'),
      api.get('/sicil/son-eklenenler'),
      api.get('/tanimlar/sirket-tipleri'),
      api.get('/tanimlar/oda-kayit'),
      api.get('/tanimlar/nace-kodlari'),
    ]).then(([rt, st, ft, mh, se, sirket, oda, nace]) => {
      setRuhsatTurleri(rt.data);
      setSicilTipleri(st.data);
      setFaaliyetleri(ft.data);
      setMahalleler(mh.data);
      setSonEklenenler(se.data);
      setSirketTipleri(sirket.data);
      setOdaKayitlari(oda.data);
      setNaceKodlari(nace.data);
    });

    if (duzenleme) {
      api.get(`/ruhsat/${id}`).then(r => {
        const d = r.data;
        setForm({
          sicil_id: d.sicil_id || '', unvan: d.unvan || '', firma_adi: d.firma_adi || d.unvan || '', firma_unvani: d.firma_unvani || '', ruhsat_turu_id: d.ruhsat_turu_id || '',
          sicil_tipi_id: d.sicil_tipi_id || '', tcno: d.tcno || '', vn: d.vn || '', vd: d.vd || '',
          isyeri_adresi: d.isyeri_adresi || '', is_diskapi: d.is_diskapi || '', is_ickapi: d.is_ickapi || '',
          is_katno: d.is_katno || '', is_il: d.is_il || 'ORDU', is_ilce: d.is_ilce || 'ÜNYE',
          mahalle: d.mahalle || '', sokak: d.sokak || '', ada: d.ada || '', pafta: d.pafta || '', parsel: d.parsel || '',
          gis_mahalle_id: d.gis_mahalle_id || '', gis_yol_id: d.gis_yol_id || '', gis_kapi_id: d.gis_kapi_id || '',
          ana_faaliyet_id: d.ana_faaliyet_id || '', kapali_alan: d.kapali_alan || '', acik_alan: d.acik_alan || '',
          kapasite: d.kapasite || '', kapasite_tip: d.kapasite_tip || '', oda_sayisi: d.oda_sayisi || '',
          sgk_sayisi: d.sgk_sayisi || '', mulk: d.mulk || '', mulk_sahibi_id: d.mulk_sahibi_id || '', yer: d.yer || '', takip_suresi: d.takip_suresi || '',
          basvuru_tarihi: d.basvuru_tarihi ? d.basvuru_tarihi.split('T')[0] : new Date().toISOString().split('T')[0],
          yaz_acilis_saati: d.yaz_acilis_saati || '', yaz_kapanis_saati: d.yaz_kapanis_saati || '',
          kis_acilis_saati: d.kis_acilis_saati || '', kis_kapanis_saati: d.kis_kapanis_saati || '',
          depo_adresi: d.depo_adresi || '', depo_diskapi: d.depo_diskapi || '', depo_ickapi: d.depo_ickapi || '',
          depo_katno: d.depo_katno || '', depo_il: d.depo_il || '', depo_ilce: d.depo_ilce || '',
          yapi_kayit_belgesi: d.yapi_kayit_belgesi || '', ebelgeno: d.ebelgeno || '', sirket_tipi_id: d.sirket_tipi_id || '',
          oda_kayit_id: d.oda_kayit_id || '', nace_kodu_id: d.nace_kodu_id || '',
        });
        if (d.nace_kodu_no && d.nace_kodu_adi) setNaceArama(`${d.nace_kodu_no} - ${d.nace_kodu_adi}`);
        if (d.tali_faaliyetler?.length > 0) {
          setTaliSecimler(d.tali_faaliyetler.map(tf => ({ faaliyet_id: tf.faaliyet_id, faaliyet_adi: tf.faaliyet_adi })));
        }
        // Düzenleme modunda: mevcut mahalle adına göre id bul ve yolları yükle
        if (d.gis_mahalle_id || d.mahalle) {
          api.get('/gis/mahalleler').then(mhRes => {
            const eslesme = mhRes.data.find(m => String(m.id) === String(d.gis_mahalle_id) || m.adi === d.mahalle);
            if (eslesme) {
              setSeciliMahalleId(String(eslesme.id));
              api.get(`/gis/yollar?mahalle_id=${eslesme.id}`).then(yl => {
                setYollar(yl.data);
                const yol = yl.data.find(y => String(y.id) === String(d.gis_yol_id) || y.tam_ad === d.sokak);
                if (yol) {
                  setSeciliYolId(String(yol.id));
                  api.get(`/gis/kapilar?mahalle_id=${eslesme.id}&yol_id=${yol.id}`).then(k => setKapilar(k.data));
                }
              });
            }
          });
        }
      });
    }
  }, [id, duzenleme]);

  // Mahalle seçilince yolları getir
  const mahalleSecildi = async (e) => {
    const mahalleId = e.target.value;
    setSeciliMahalleId(mahalleId);
    const seciliAdi = mahalleler.find(m => String(m.id) === mahalleId)?.adi || '';
    setSeciliYolId('');
    setKapilar([]);
    setForm(prev => ({ ...prev, mahalle: seciliAdi, sokak: '', is_diskapi: '', gis_mahalle_id: mahalleId, gis_yol_id:'', gis_kapi_id:'' }));
    if (!mahalleId) { setYollar([]); return; }
    setYolYukleniyor(true);
    try {
      const r = await api.get(`/gis/yollar?mahalle_id=${mahalleId}`);
      setYollar(r.data);
    } finally { setYolYukleniyor(false); }
  };

  const yolSecildi = async (e) => {
    const yolId = e.target.value;
    setSeciliYolId(yolId);
    const yol = yollar.find(y => String(y.id) === yolId);
    setForm(prev => ({ ...prev, sokak: yol?.tam_ad || '', is_diskapi:'', gis_yol_id:yolId, gis_kapi_id:'' }));
    setKapilar([]);
    if (!yolId) return;
    setKapiYukleniyor(true);
    try {
      const r = await api.get(`/gis/kapilar?mahalle_id=${seciliMahalleId}&yol_id=${yolId}`);
      setKapilar(r.data);
    } finally { setKapiYukleniyor(false); }
  };

  const kapiSecildi = (e) => {
    const kapiId = e.target.value;
    const kapi = kapilar.find(k => String(k.id) === kapiId);
    setForm(prev => ({ ...prev, is_diskapi:kapi?.kapi_no || '', gis_kapi_id:kapiId }));
  };

  const sicilAra = async () => {
    if (!sicilArama) return;
    const r = await api.get(`/sicil?q=${sicilArama}`);
    setSicilSonuclari(r.data);
  };

  const sicilSec = useCallback((s) => {
    setForm(f => ({
      ...f,
      sicil_id: s.id,
      tcno: s.tcno || '',
      vn: s.vn || '',
      vd: s.vd || '',
      unvan: s.unvani || (s.adi ? `${s.adi} ${s.soyadi}` : ''),
      firma_adi: s.sicil_tipi === 'TUZEL' ? (s.unvani || '') : '',
      firma_unvani: '',
      sicil_tipi_id: s.sicil_tipi === 'TUZEL' ? '2' : s.sicil_tipi === 'KAMU' ? '3' : '1',
    }));
    setSicilSonuclari([]);
    setSicilArama(s.unvani || `${s.adi} ${s.soyadi}`);
  }, []);

  const sicilVerileriniYenile = useCallback(async () => {
    if (!form.sicil_id) return;
    try {
      const { data: s } = await api.get(`/sicil/${form.sicil_id}`);
      sicilSec(s);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Sicil bilgileri yenilenemedi.');
    }
  }, [form.sicil_id, sicilSec]);

  useEffect(() => {
    if (!form.sicil_id) return undefined;
    const yenile = () => sicilVerileriniYenile();
    const mesajlaYenile = (event) => {
      if (event.origin !== window.location.origin) return;
      if (event.data?.type === 'SICIL_GUNCELLENDI' && String(event.data.sicilId) === String(form.sicil_id)) yenile();
    };
    window.addEventListener('focus', yenile);
    window.addEventListener('message', mesajlaYenile);
    return () => {
      window.removeEventListener('focus', yenile);
      window.removeEventListener('message', mesajlaYenile);
    };
  }, [form.sicil_id, sicilVerileriniYenile]); // Sicil düzenleme sekmesinden dönüldüğünde güncel veriyi al.

  const faaliyetKaydet = async () => {
    if (!faaliyetModal?.faaliyet_adi?.trim() || !faaliyetModal?.sinif_adi) return;
    try {
      const { data } = await api.post('/tanimlar/faaliyet-turleri', {
        faaliyet_kodu: faaliyetModal.faaliyet_kodu?.trim() || null,
        faaliyet_adi: faaliyetModal.faaliyet_adi.trim(),
        sinif_adi: faaliyetModal.sinif_adi,
      });
      setFaaliyetleri(prev => [...prev, data].sort((a, b) => a.faaliyet_adi.localeCompare(b.faaliyet_adi, 'tr')));
      if (faaliyetModal.hedef === 'ana') setForm(prev => ({ ...prev, ana_faaliyet_id: data.id }));
      else setTaliSecimler(prev => [...prev, { faaliyet_id: data.id, faaliyet_adi: data.faaliyet_adi }]);
      setFaaliyetModal(null);
    } catch (err) {
      setHata(err.response?.data?.hata || 'Faaliyet eklenemedi.');
    }
  };

  const odaKaydet = async () => {
    if (!odaModal?.oda_adi?.trim()) return;
    try {
      const { data } = await api.post('/tanimlar/oda-kayit', { oda_adi: odaModal.oda_adi.trim(), oda_kodu: odaModal.oda_kodu?.trim() || null });
      setOdaKayitlari(prev => [...prev, data].sort((a, b) => a.oda_adi.localeCompare(b.oda_adi, 'tr')));
      setForm(prev => ({ ...prev, oda_kayit_id: data.id }));
      setOdaModal(null);
    } catch (err) { setHata(err.response?.data?.hata || 'Oda eklenemedi.'); }
  };

  const naceKaydet = async () => {
    if (!naceModal?.nace_kodu?.trim() || !naceModal?.nace_adi?.trim()) return;
    try {
      const { data } = await api.post('/tanimlar/nace-kodlari', { nace_kodu: naceModal.nace_kodu.trim(), nace_adi: naceModal.nace_adi.trim(), bolum: naceModal.bolum?.trim() || null });
      setNaceKodlari(prev => [...prev, data].sort((a, b) => a.nace_kodu.localeCompare(b.nace_kodu)));
      setForm(prev => ({ ...prev, nace_kodu_id: data.id }));
      setNaceModal(null);
    } catch (err) { setHata(err.response?.data?.hata || 'NACE kodu eklenemedi.'); }
  };

  const handleTaslakKaydet = async () => {
    setHata('');
    setKaydediliyor(true);
    try {
      const payload = { ...form, tali_faaliyetler: taliSecimler, taslak: true };
      if (duzenleme) {
        await api.put(`/ruhsat/${id}`, payload);
        navigate(`/ruhsat/${id}`);
      } else {
        const r = await api.post('/ruhsat', payload);
        navigate(`/ruhsat/${r.data.id}`);
      }
    } catch (err) { setHata(err.response?.data?.hata || 'Taslak kaydedilemedi.'); }
    finally { setKaydediliyor(false); }
  };

  const adresKaydet = () => {
    const mahalleAdi = mahalleler.find(m => String(m.id) === String(seciliMahalleId))?.adi || '';
    const yolAdi = yollar.find(y => String(y.id) === String(seciliYolId))?.tam_ad || '';
    if (!mahalleAdi || !yolAdi || !form.is_diskapi) return setHata('Mahalle, cadde/sokak ve dış kapı numarası seçilmelidir.');
    const adres = `${mahalleAdi} Mahallesi ${yolAdi} No:${form.is_diskapi}${form.is_ickapi ? ` İç Kapı:${form.is_ickapi}` : ''}${form.is_katno ? ` Kat:${form.is_katno}` : ''} ORDU/ÜNYE 52300`;
    setForm(prev => ({ ...prev, isyeri_adresi: adres, mahalle: mahalleAdi, sokak: yolAdi, is_il: 'ORDU', is_ilce: 'ÜNYE' }));
    setHata('');
    setAdresModalAcik(false);
  };

  const depoMahalleSecildi = async (e) => {
    const mahalleId = e.target.value;
    setDepoSeciliMahalleId(mahalleId);
    setDepoSeciliYolId('');
    setDepoKapilar([]);
    setForm(prev => ({ ...prev, depo_adresi: '', depo_diskapi: '', depo_il: 'ORDU', depo_ilce: 'ÜNYE' }));
    if (!mahalleId) { setDepoYollar([]); return; }
    setDepoYolYukleniyor(true);
    try {
      const r = await api.get(`/gis/yollar?mahalle_id=${mahalleId}`);
      setDepoYollar(r.data);
    } finally { setDepoYolYukleniyor(false); }
  };

  const depoYolSecildi = async (e) => {
    const yolId = e.target.value;
    setDepoSeciliYolId(yolId);
    setDepoKapilar([]);
    setForm(prev => ({ ...prev, depo_diskapi: '' }));
    if (!yolId) return;
    setDepoKapiYukleniyor(true);
    try {
      const r = await api.get(`/gis/kapilar?mahalle_id=${depoSeciliMahalleId}&yol_id=${yolId}`);
      setDepoKapilar(r.data);
    } finally { setDepoKapiYukleniyor(false); }
  };

  const depoKapiSecildi = (e) => {
    const kapiId = e.target.value;
    const kapi = depoKapilar.find(k => String(k.id) === kapiId);
    setForm(prev => ({ ...prev, depo_diskapi: kapi?.kapi_no || '' }));
  };

  const depoAdresKaydet = () => {
    const mahalleAdi = mahalleler.find(m => String(m.id) === String(depoSeciliMahalleId))?.adi || '';
    const yolAdi = depoYollar.find(y => String(y.id) === String(depoSeciliYolId))?.tam_ad || '';
    if (!mahalleAdi || !yolAdi || !form.depo_diskapi) return setHata('Mahalle, cadde/sokak ve dış kapı numarası seçilmelidir.');
    const adres = `${mahalleAdi} Mahallesi ${yolAdi} No:${form.depo_diskapi}${form.depo_ickapi ? ` İç Kapı:${form.depo_ickapi}` : ''}${form.depo_katno ? ` Kat:${form.depo_katno}` : ''} ORDU/ÜNYE 52300`;
    setForm(prev => ({ ...prev, depo_adresi: adres, depo_il: 'ORDU', depo_ilce: 'ÜNYE' }));
    setHata('');
    setDepoAdresModalAcik(false);
  };

  const f = (k) => (e) => setForm({...form, [k]: e.target.value});

  const handleVnChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 10);
    setForm({...form, vn: digits});
  };

  const handleVnValidate = (e) => {
    const v = e.target.value;
    if (v && v.length !== 10) {
      e.target.setCustomValidity('Vergi numarası 10 haneli olmalıdır');
    } else {
      e.target.setCustomValidity('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHata('');

    if (!form.sicil_id) {
      return setHata('Sicil kaydı seçilmeden ruhsat kaydedilemez. Lütfen yukarıdaki sicil arama alanından bir sicil seçin.');
    }

    const tcDigits = form.tcno.replace(/\D/g, '');
    if (form.tcno && tcDigits.length !== 11) {
      return setHata('T.C. Kimlik No 11 haneli olmalıdır.');
    }
    const vnDigits = form.vn.replace(/\D/g, '');
    if (form.vn && vnDigits.length !== 10) {
      return setHata('Vergi numarası 10 haneli olmalıdır.');
    }

    setKaydediliyor(true);
    try {
      const payload = { ...form, tali_faaliyetler: taliSecimler };
      if (duzenleme) {
        await api.put(`/ruhsat/${id}`, payload);
        navigate(`/ruhsat/${id}`);
      } else {
        const r = await api.post('/ruhsat', payload);
        navigate(`/ruhsat/${r.data.id}`);
      }
    } catch (err) {
      setHata(err.response?.data?.hata || 'Kayıt hatası');
    } finally { setKaydediliyor(false); }
  };

  return (
    <div>
      <div style={{marginBottom:'20px'}}>
        <button className="btn btn-secondary btn-sm" onClick={() => navigate(-1)} style={{marginBottom:'8px'}}>← Geri</button>
        <h2 style={{color:'#1a237e', fontSize:'20px'}}>{duzenleme ? '✏️ Ruhsat Düzenle' : '➕ Yeni Ruhsat Başvurusu'}</h2>
      </div>

      {hata && <div className="alert alert-error">{hata}</div>}

      {faaliyetModal && (
        <div className="form-modal-backdrop" onMouseDown={() => setFaaliyetModal(null)}>
          <div className="form-modal" role="dialog" aria-modal="true" aria-labelledby="faaliyet-modal-baslik" onMouseDown={e => e.stopPropagation()}>
            <h3 id="faaliyet-modal-baslik">Yeni {faaliyetModal.hedef === 'ana' ? 'ana' : 'tali'} faaliyet</h3>
            <div className="form-group"><label>Faaliyet adı *</label><input autoFocus value={faaliyetModal.faaliyet_adi} onChange={e => setFaaliyetModal({...faaliyetModal, faaliyet_adi:e.target.value})} /></div>
            <div className="form-group"><label>Faaliyet sınıfı *</label><select value={faaliyetModal.sinif_adi} onChange={e => setFaaliyetModal({...faaliyetModal, sinif_adi:e.target.value})}><option value="">Seçin...</option><option>Sıhhi</option><option>Gayrisıhhi</option><option>Umuma Açık</option></select></div>
            <div className="form-group"><label>Faaliyet kodu</label><input value={faaliyetModal.faaliyet_kodu} onChange={e => setFaaliyetModal({...faaliyetModal, faaliyet_kodu:e.target.value})} /></div>
            <div className="form-modal-actions"><button type="button" className="btn btn-secondary" onClick={() => setFaaliyetModal(null)}>İptal</button><button type="button" className="btn btn-primary" onClick={faaliyetKaydet}>Kaydet</button></div>
          </div>
        </div>
      )}

      {odaModal && (
        <div className="form-modal-backdrop" onMouseDown={() => setOdaModal(null)}>
          <div className="form-modal" role="dialog" aria-modal="true" onMouseDown={e => e.stopPropagation()}>
            <h3>Yeni Oda Kaydı</h3>
            <div className="form-group"><label>Oda Adı *</label><input autoFocus value={odaModal.oda_adi} onChange={e => setOdaModal({...odaModal, oda_adi:e.target.value})} /></div>
            <div className="form-group"><label>Oda Kodu</label><input value={odaModal.oda_kodu} onChange={e => setOdaModal({...odaModal, oda_kodu:e.target.value})} placeholder="TSO, ESO..." /></div>
            <div className="form-modal-actions"><button type="button" className="btn btn-secondary" onClick={() => setOdaModal(null)}>İptal</button><button type="button" className="btn btn-primary" onClick={odaKaydet}>Kaydet</button></div>
          </div>
        </div>
      )}

      {naceModal && (
        <div className="form-modal-backdrop" onMouseDown={() => setNaceModal(null)}>
          <div className="form-modal" role="dialog" aria-modal="true" onMouseDown={e => e.stopPropagation()}>
            <h3>Yeni NACE Kodu</h3>
            <div className="form-group"><label>NACE Kodu *</label><input autoFocus value={naceModal.nace_kodu} onChange={e => setNaceModal({...naceModal, nace_kodu:e.target.value})} placeholder="00.00.00" maxLength={8} /></div>
            <div className="form-group"><label>Açıklama *</label><input value={naceModal.nace_adi} onChange={e => setNaceModal({...naceModal, nace_adi:e.target.value})} /></div>
            <div className="form-group"><label>Bölüm</label><input value={naceModal.bolum} onChange={e => setNaceModal({...naceModal, bolum:e.target.value})} placeholder="Örn: J - Bilgi ve İletişim" /></div>
            <div className="form-modal-actions"><button type="button" className="btn btn-secondary" onClick={() => setNaceModal(null)}>İptal</button><button type="button" className="btn btn-primary" onClick={naceKaydet}>Kaydet</button></div>
          </div>
        </div>
      )}

      {adresModalAcik && (
        <div className="form-modal-backdrop" onMouseDown={() => setAdresModalAcik(false)}>
          <div className="form-modal form-modal-wide" role="dialog" aria-modal="true" aria-labelledby="adres-modal-baslik" onMouseDown={e => e.stopPropagation()}>
            <h3 id="adres-modal-baslik">İşyeri adresi seç</h3>
            <div className="form-grid address-modal-grid">
              <div className="form-group"><label>Mahalle *</label><select value={seciliMahalleId} onChange={mahalleSecildi}><option value="">Seçin...</option>{mahalleler.map(m => <option key={m.id} value={m.id}>{m.adi}</option>)}</select></div>
              <div className="form-group"><label>Cadde / Sokak *</label><select value={seciliYolId} onChange={yolSecildi} disabled={!seciliMahalleId || yolYukleniyor}><option value="">Seçin...</option>{yollar.map(y => <option key={y.id} value={y.id}>{y.tam_ad}</option>)}</select></div>
              <div className="form-group"><label>Dış Kapı No *</label><select value={form.gis_kapi_id} onChange={kapiSecildi} disabled={!seciliYolId || kapiYukleniyor}><option value="">Seçin...</option>{kapilar.map(k => <option key={k.id} value={k.id}>{k.kapi_no}</option>)}</select></div>
              <div className="form-group"><label>İç Kapı No</label><input value={form.is_ickapi} onChange={f('is_ickapi')} /></div>
              <div className="form-group"><label>Kat No</label><input value={form.is_katno} onChange={f('is_katno')} /></div>
            </div>
            <div className="address-preview">{form.isyeri_adresi || 'Seçimler tamamlandığında adres burada oluşturulur.'}</div>
            <div className="form-modal-actions"><button type="button" className="btn btn-secondary" onClick={() => setAdresModalAcik(false)}>İptal</button><button type="button" className="btn btn-primary" onClick={adresKaydet}>Adresi kaydet</button></div>
          </div>
        </div>
      )}

      {depoAdresModalAcik && (
        <div className="form-modal-backdrop" onMouseDown={() => setDepoAdresModalAcik(false)}>
          <div className="form-modal form-modal-wide" role="dialog" aria-modal="true" onMouseDown={e => e.stopPropagation()}>
            <h3>Depo adresi seç</h3>
            <div className="form-grid address-modal-grid">
              <div className="form-group"><label>Mahalle *</label><select value={depoSeciliMahalleId} onChange={depoMahalleSecildi}><option value="">Seçin...</option>{mahalleler.map(m => <option key={m.id} value={m.id}>{m.adi}</option>)}</select></div>
              <div className="form-group"><label>Cadde / Sokak *</label><select value={depoSeciliYolId} onChange={depoYolSecildi} disabled={!depoSeciliMahalleId || depoYolYukleniyor}><option value="">Seçin...</option>{depoYollar.map(y => <option key={y.id} value={y.id}>{y.tam_ad}</option>)}</select></div>
              <div className="form-group"><label>Dış Kapı No *</label><select onChange={depoKapiSecildi} disabled={!depoSeciliYolId || depoKapiYukleniyor}><option value="">Seçin...</option>{depoKapilar.map(k => <option key={k.id} value={k.id}>{k.kapi_no}</option>)}</select></div>
              <div className="form-group"><label>İç Kapı No</label><input value={form.depo_ickapi} onChange={f('depo_ickapi')} /></div>
              <div className="form-group"><label>Kat No</label><input value={form.depo_katno} onChange={f('depo_katno')} /></div>
            </div>
            <div className="address-preview">{form.depo_adresi || 'Seçimler tamamlandığında adres burada oluşturulur.'}</div>
            <div className="form-modal-actions"><button type="button" className="btn btn-secondary" onClick={() => setDepoAdresModalAcik(false)}>İptal</button><button type="button" className="btn btn-primary" onClick={depoAdresKaydet}>Adresi kaydet</button></div>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        {/* Sicil Arama */}
        <div className="card">
          <div className="card-header"><span className="card-title">Sahip / Firma Bilgileri</span></div>
          <div style={{marginBottom:'16px'}}>
            <label style={{fontSize:'12px', fontWeight:'600', color: form.sicil_id ? '#2e7d32' : '#c62828', display:'block', marginBottom:'4px'}}>
              Sicil Kaydı * {form.sicil_id ? '✓ Seçildi' : '— Seçilmeden kayıt yapılamaz'}
            </label>
            <div className="license-registry-actions" style={{display:'flex', gap:'8px'}}>
              <input value={sicilArama} onChange={e => { setSicilArama(e.target.value); if (!e.target.value) setSicilSonuclari([]); }} placeholder="Ad, soyad, TC, vergi no..." className="search-input" onKeyDown={e => e.key==='Enter' && (e.preventDefault(), sicilAra())} />
              <button type="button" className="btn btn-outline" onClick={sicilAra}>🔍 Ara</button>
              <button type="button" className="btn btn-secondary" onClick={() => window.open('/sicil/yeni', '_blank', 'noopener')}>+ Yeni oluştur</button>
              {form.sicil_id && <button type="button" className="btn btn-outline" onClick={() => window.open(`/sicil/${form.sicil_id}/duzenle?ruhsataDon=1`, 'sicilGuncelle', 'width=1180,height=820,scrollbars=yes,resizable=yes')}>Sicil güncelle</button>}
            </div>
            {/* Son eklenenler - arama yapılmadıysa göster */}
            {!sicilArama && sicilSonuclari.length === 0 && sonEklenenler.length > 0 && (
              <div style={{marginTop:'8px'}}>
                <div style={{fontSize:'11px', color:'#888', marginBottom:'4px', fontWeight:'600'}}>SON EKLENEN SİCİLLER</div>
                <div style={{border:'1px solid #e0e0e0', borderRadius:'4px', background:'#fafafa'}}>
                  {sonEklenenler.map(s => (
                    <div key={s.id} onClick={() => sicilSec(s)}
                      style={{padding:'8px 12px', cursor:'pointer', borderBottom:'1px solid #f0f0f0', fontSize:'13px', display:'flex', justifyContent:'space-between', alignItems:'center'}}
                      onMouseOver={e => e.currentTarget.style.background='#f0f4ff'}
                      onMouseOut={e => e.currentTarget.style.background='transparent'}>
                      <strong>{s.tam_ad}</strong>
                      <span style={{color:'#999', fontSize:'11px'}}>{s.tcno || s.vn}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {sicilSonuclari.length > 0 && (
              <div style={{border:'1px solid #ddd', borderRadius:'4px', marginTop:'4px', maxHeight:'200px', overflowY:'auto', background:'white'}}>
                {sicilSonuclari.map(s => (
                  <div key={s.id} onClick={() => sicilSec(s)}
                    style={{padding:'8px 12px', cursor:'pointer', borderBottom:'1px solid #f0f0f0', fontSize:'13px'}}
                    onMouseOver={e => e.currentTarget.style.background='#f5f5ff'}
                    onMouseOut={e => e.currentTarget.style.background='white'}>
                    <strong>{s.unvani || `${s.adi} ${s.soyadi}`}</strong>
                    <span style={{color:'#999', marginLeft:'8px', fontSize:'11px'}}>{s.tcno || s.vn}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="form-grid">
            <div className="form-group"><label>T.C. Kimlik No</label><input value={form.tcno} onChange={f('tcno')} placeholder="11 hane" maxLength={11} /></div>
            <div className="form-group"><label>Vergi No</label><input value={form.vn} onChange={handleVnChange} onInvalid={handleVnValidate} onInput={handleVnValidate} placeholder="10 haneli vergi numarası" maxLength={10} inputMode="numeric" /></div>
            <div className="form-group"><label>Vergi Dairesi</label><input value={form.vd} onChange={f('vd')} /></div>
          </div>
        </div>

        {/* İşyeri Bilgileri */}
        <div className="card">
          <div className="card-header"><span className="card-title">İşyeri Bilgileri</span></div>
          <div className="form-grid">
            {String(form.sicil_tipi_id) === '2' ? <>
              <div className="form-group" style={{gridColumn:'1/-1'}}>
                <label>Firma Adı *</label>
                <input value={form.firma_adi} onChange={e => setForm({...form, firma_adi:e.target.value, unvan:e.target.value})} required placeholder="Firmanın adı" />
              </div>
              <div className="form-group" style={{gridColumn:'1/-1'}}>
                <label>Firma Ünvanı</label>
                <input value={form.firma_unvani} onChange={f('firma_unvani')} placeholder="Firmanın ticari ünvanı" />
              </div>
            </> : (
              <div className="form-group" style={{gridColumn:'1/-1'}}>
                <label>İşyeri Ünvanı *</label>
                <input value={form.unvan} onChange={f('unvan')} required placeholder="İşyerinin tam ünvanı" />
              </div>
            )}
            <div className="form-group">
              <label>Ruhsat Türü *</label>
              <select value={form.ruhsat_turu_id} onChange={f('ruhsat_turu_id')} required>
                <option value="">Seçin...</option>
                {ruhsatTurleri.map(r => <option key={r.id} value={r.id}>{r.tur_adi}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Sicil Tipi *</label>
              <select value={form.sicil_tipi_id} onChange={f('sicil_tipi_id')} required>
                <option value="">Seçin...</option>
                {sicilTipleri.map(s => <option key={s.id} value={s.id}>{s.tip_adi}</option>)}
              </select>
            </div>
            {String(form.sicil_tipi_id) === '2' && (
              <div className="form-group">
                <label>Şirket Türü</label>
                <select value={form.sirket_tipi_id} onChange={f('sirket_tipi_id')}>
                  <option value="">Seçin...</option>
                  {sirketTipleri.map(s => <option key={s.id} value={s.id}>{s.tip_adi}</option>)}
                </select>
              </div>
            )}
            <div className="form-group">
              <label className="field-label-with-action"><span>Ana Faaliyet</span><button type="button" className="inline-add-button" aria-label="Yeni ana faaliyet ekle" onClick={() => setFaaliyetModal({hedef:'ana', faaliyet_adi:'', sinif_adi:'', faaliyet_kodu:''})}>+</button></label>
              <select value={form.ana_faaliyet_id} onChange={f('ana_faaliyet_id')}>
                <option value="">Seçin...</option>
                {['Sıhhi','Gayrisıhhi','Umuma Açık'].map(sinif => {
                  const gr = faaliyetleri.filter(fa => fa.sinif_adi === sinif);
                  return gr.length > 0 ? <optgroup key={sinif} label={sinif}>{gr.map(fa => <option key={fa.id} value={fa.id}>{fa.faaliyet_adi}</option>)}</optgroup> : null;
                })}
                {faaliyetleri.filter(fa => !['Sıhhi','Gayrisıhhi','Umuma Açık'].includes(fa.sinif_adi)).length > 0 && (
                  <optgroup label="Diğer">
                    {faaliyetleri.filter(fa => !['Sıhhi','Gayrisıhhi','Umuma Açık'].includes(fa.sinif_adi)).map(fa => <option key={fa.id} value={fa.id}>{fa.faaliyet_adi}</option>)}
                  </optgroup>
                )}
              </select>
            </div>
            <div className="form-group">
              <label className="field-label-with-action"><span>Tali Faaliyet(ler)</span><button type="button" className="inline-add-button" aria-label="Yeni tali faaliyet ekle" onClick={() => setFaaliyetModal({hedef:'tali', faaliyet_adi:'', sinif_adi:'', faaliyet_kodu:''})}>+</button></label>
              <div>
                {taliSecimler.map((t, i) => (
                  <div key={i} style={{display:'flex', gap:'6px', marginBottom:'4px', alignItems:'center'}}>
                    <span style={{flex:1, fontSize:'13px', padding:'4px 8px', background:'#e8eaf6', borderRadius:'4px', color:'#1a237e'}}>{t.faaliyet_adi}</span>
                    <button type="button" onClick={() => setTaliSecimler(taliSecimler.filter((_,j)=>j!==i))}
                      style={{background:'#ffebee', border:'1px solid #ef9a9a', borderRadius:'4px', padding:'3px 8px', cursor:'pointer', color:'#c62828'}}>✕</button>
                  </div>
                ))}
                <select value="" onChange={e => {
                  const id = e.target.value;
                  if (!id) return;
                  const fa = faaliyetleri.find(f => String(f.id) === id);
                  if (fa && !taliSecimler.find(t => String(t.faaliyet_id) === id)) {
                    setTaliSecimler([...taliSecimler, {faaliyet_id: fa.id, faaliyet_adi: fa.faaliyet_adi}]);
                  }
                  e.target.value = '';
                }} style={{width:'100%', marginTop:'4px'}}>
                  <option value="">+ Tali faaliyet ekle...</option>
                  {['Sıhhi','Gayrisıhhi','Umuma Açık'].map(sinif => {
                    const gr = faaliyetleri.filter(fa => fa.sinif_adi === sinif && !taliSecimler.find(t=>String(t.faaliyet_id)===String(fa.id)));
                    return gr.length > 0 ? <optgroup key={sinif} label={sinif}>{gr.map(fa => <option key={fa.id} value={fa.id}>{fa.faaliyet_adi}</option>)}</optgroup> : null;
                  })}
                  {faaliyetleri.filter(fa => !['Sıhhi','Gayrisıhhi','Umuma Açık'].includes(fa.sinif_adi) && !taliSecimler.find(t=>String(t.faaliyet_id)===String(fa.id))).length > 0 && (
                    <optgroup label="Diğer">
                      {faaliyetleri.filter(fa => !['Sıhhi','Gayrisıhhi','Umuma Açık'].includes(fa.sinif_adi) && !taliSecimler.find(t=>String(t.faaliyet_id)===String(fa.id))).map(fa => <option key={fa.id} value={fa.id}>{fa.faaliyet_adi}</option>)}
                    </optgroup>
                  )}
                </select>
              </div>
            </div>
            <div className="form-group">
              <label>Yapı Kayıt Belgesi</label>
              <input value={form.yapi_kayit_belgesi} onChange={f('yapi_kayit_belgesi')} placeholder="Yapı kayıt belgesi no veya türü" />
            </div>
            <div className="form-group">
              <label>Başvuru Tarihi</label>
              <input type="date" value={form.basvuru_tarihi} onChange={f('basvuru_tarihi')} />
            </div>
            <div className="form-group">
              <label className="field-label-with-action"><span>Hangi Odaya Kayıtlı</span><button type="button" className="inline-add-button" aria-label="Yeni oda ekle" onClick={() => setOdaModal({oda_adi:'', oda_kodu:''})}>+</button></label>
              <select value={form.oda_kayit_id} onChange={f('oda_kayit_id')}>
                <option value="">Seçin...</option>
                {odaKayitlari.map(o => <option key={o.id} value={o.id}>{o.oda_adi}{o.oda_kodu ? ` (${o.oda_kodu})` : ''}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="field-label-with-action"><span>NACE Kodu</span><button type="button" className="inline-add-button" aria-label="Yeni NACE kodu ekle" onClick={() => setNaceModal({nace_kodu:'', nace_adi:'', bolum:''})}>+</button></label>
              <input
                value={naceArama}
                onChange={e => { setNaceArama(e.target.value); if (!e.target.value) setForm(prev => ({...prev, nace_kodu_id:''})); }}
                placeholder="Kod veya açıklama ile ara..."
                list="nace-liste"
                onFocus={() => { const sec = naceKodlari.find(n => String(n.id) === String(form.nace_kodu_id)); if (sec) setNaceArama(`${sec.nace_kodu} - ${sec.nace_adi}`); }}
              />
              <datalist id="nace-liste">
                {naceKodlari.filter(n => !naceArama || `${n.nace_kodu} ${n.nace_adi}`.toLowerCase().includes(naceArama.toLowerCase())).slice(0,50).map(n => (
                  <option key={n.id} value={`${n.nace_kodu} - ${n.nace_adi}`} />
                ))}
              </datalist>
              {naceArama && (() => {
                const eslesme = naceKodlari.find(n => `${n.nace_kodu} - ${n.nace_adi}` === naceArama);
                if (eslesme && String(form.nace_kodu_id) !== String(eslesme.id)) {
                  setTimeout(() => setForm(prev => ({...prev, nace_kodu_id: eslesme.id})), 0);
                }
                return null;
              })()}
            </div>
          </div>
        </div>

        {/* Adres */}
        <div className="card">
          <div className="card-header"><span className="card-title">Adres Bilgileri</span></div>
          <div className="form-grid">
            <div className="form-group" style={{gridColumn:'1/-1'}}>
              <label className="field-label-with-action"><span>İşyeri Adresi</span><button type="button" className="inline-add-button" aria-label="Adres seç" onClick={() => setAdresModalAcik(true)}>+</button></label>
              <textarea value={form.isyeri_adresi} readOnly rows={2} placeholder="Adres seçmek için + düğmesini kullanın" />
            </div>
            <div className="form-group"><label>Ada</label><input value={form.ada} onChange={f('ada')} /></div>
            <div className="form-group"><label>Parsel</label><input value={form.parsel} onChange={f('parsel')} /></div>
            <div className="form-group"><label>E-Belge No</label><input type="text" value={form.ebelgeno} onChange={f('ebelgeno')} maxLength={100} placeholder="E-belge numarası" /></div>
          </div>
        </div>

        {/* Depo Adresi */}
        <div className="card">
          <div className="card-header"><span className="card-title">Depo Adresi</span></div>
          <div className="form-grid">
            <div className="form-group" style={{gridColumn:'1/-1'}}>
              <label className="field-label-with-action"><span>Depo Adresi</span><button type="button" className="inline-add-button" aria-label="Depo adresi seç" onClick={() => setDepoAdresModalAcik(true)}>+</button></label>
              <textarea value={form.depo_adresi} readOnly rows={2} placeholder="Depo adresi seçmek için + düğmesini kullanın" />
            </div>
          </div>
        </div>

        {/* Alan ve Kapasite */}
        <div className="card">
          <div className="card-header"><span className="card-title">Alan & Kapasite Bilgileri</span></div>
          <div className="form-grid">
            <div className="form-group"><label>Kapalı Alan (m²)</label><input type="number" step="0.01" value={form.kapali_alan} onChange={f('kapali_alan')} /></div>
            <div className="form-group"><label>Açık Alan (m²)</label><input type="number" step="0.01" value={form.acik_alan} onChange={f('acik_alan')} /></div>
            <div className="form-group"><label>Kapasite</label><input type="number" value={form.kapasite} onChange={f('kapasite')} /></div>
            <div className="form-group"><label>Kapasite Türü</label><input value={form.kapasite_tip} onChange={f('kapasite_tip')} placeholder="kişi, araç, yatak..." /></div>
            <div className="form-group"><label>Oda Sayısı</label><input type="number" value={form.oda_sayisi} onChange={f('oda_sayisi')} /></div>
            <div className="form-group"><label>SGK'lı Çalışan</label><input type="number" value={form.sgk_sayisi} onChange={f('sgk_sayisi')} /></div>
            <div className="form-group">
              <label>Mülk Durumu</label>
              <select value={form.mulk} onChange={f('mulk')}>
                <option value="">Seçin...</option>
                <option value="Kira">Kira</option>
                <option value="Mülk Sahibi">Mülk Sahibi</option>
                <option value="Tahsis">Tahsis</option>
                <option value="Diğer">Diğer</option>
              </select>
            </div>
            <div className="form-group">
              <label className="field-label-with-action"><span>Yer / Bölge</span><button type="button" className="inline-add-button" aria-label="Yeni yer veya bölge ekle" onClick={yeniYerBolgeEkle}>+</button></label>
              <select value={form.yer} onChange={f('yer')}>
                <option value="">Seçin...</option>
                {form.yer && !yerBolgeSecenekleri.includes(form.yer) && <option value={form.yer}>{form.yer}</option>}
                {yerBolgeSecenekleri.map(ad => <option key={ad} value={ad}>{ad}</option>)}
              </select>
            </div>
            <div className="form-group"><label>Takip Süresi (gün)</label><input type="number" value={form.takip_suresi} onChange={f('takip_suresi')} placeholder="Gün sayısı" /></div>
          </div>
        </div>

        {/* Çalışma Saatleri */}
        <div className="card">
          <div className="card-header"><span className="card-title">Çalışma Saatleri</span></div>
          <div className="form-grid">
            <div className="form-group"><label>Yaz Açılış (16 Mar - 14 Eki)</label><input type="time" value={form.yaz_acilis_saati} onChange={f('yaz_acilis_saati')} /></div>
            <div className="form-group"><label>Yaz Kapanış</label><input type="time" value={form.yaz_kapanis_saati} onChange={f('yaz_kapanis_saati')} /></div>
            <div className="form-group"><label>Kış Açılış (15 Eki - 15 Mar)</label><input type="time" value={form.kis_acilis_saati} onChange={f('kis_acilis_saati')} /></div>
            <div className="form-group"><label>Kış Kapanış</label><input type="time" value={form.kis_kapanis_saati} onChange={f('kis_kapanis_saati')} /></div>
          </div>
        </div>

        <div style={{display:'flex', gap:'8px', justifyContent:'flex-end', marginTop:'8px'}}>
          <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)}>İptal</button>
          <button type="button" className="btn btn-outline" disabled={kaydediliyor} onClick={handleTaslakKaydet}>
            📝 Taslak Kaydet
          </button>
          <button type="submit" className="btn btn-primary" disabled={kaydediliyor}>
            {kaydediliyor ? 'Kaydediliyor...' : (duzenleme ? '💾 Güncelle' : '✅ Başvuruyu Kaydet')}
          </button>
        </div>
      </form>
    </div>
  );
}
